module.exports = __webpack_public_path__ + "static/media/Felicity.13949092.png";